//-----------------------------------
// scripts.js
// Author: @codymarcoux (Studio123)
//
// NOTE: Main scripts file
//-----------------------------------

let menu = setupMenu();